import { setDebugCheckReporter } from 'utils/debug-check';

import { isPopDevToolsEnabled } from '../enabled';
import { popDevTools } from '../pop-devtools';
import { compactString, summarizeError, summarizeValue } from './summary';

let installed = false;

const getReasonMessage = (reason: unknown) => {
  if (reason instanceof Error) return reason.message;
  if (typeof reason === 'string') return reason;
  return compactString(String(summarizeValue(reason)));
};

const recordError = (kind: string, message: string, data: unknown) => {
  popDevTools.record({
    channel: 'errors',
    level: 'error',
    message,
    data: {
      kind,
      error: data,
    },
  });
  popDevTools.record({
    channel: 'errors',
    level: 'error',
    message: `ERROR ${message}`,
    data: {
      kind,
    },
    isMarker: true,
  });
};

const recordDebugCheckFailure = (message: string) => {
  if (!isPopDevToolsEnabled()) return;
  recordError('debugCheck', `debugCheck failed: ${message}`, { message });
};

const onWindowError = (event: ErrorEvent) => {
  recordError('error', event.message || 'window error', {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    error: summarizeError(event.error),
  });
};

const onUnhandledRejection = (event: PromiseRejectionEvent) => {
  recordError('unhandledrejection', `unhandled rejection: ${getReasonMessage(event.reason)}`, {
    reason: summarizeError(event.reason),
  });
};

export const installErrorsTap = () => {
  if (installed || !isPopDevToolsEnabled()) return;
  installed = true;

  window.addEventListener('error', onWindowError);
  window.addEventListener('unhandledrejection', onUnhandledRejection);
  setDebugCheckReporter(recordDebugCheckFailure);
};

export const uninstallErrorsTapForTests = () => {
  window.removeEventListener('error', onWindowError);
  window.removeEventListener('unhandledrejection', onUnhandledRejection);
  setDebugCheckReporter(undefined);
  installed = false;
};
